import React from "react";
import styled from "styled-components";
import { GalleryNavArrow, VideosIcon } from "../../lib/icons";
import { GalleryItemType, ModuleTypes } from "../../lib/types";
import { goToModule } from "../../actions";
import { store, dispatch, getModuleByType } from "../../store";
import { YouTubeIframeLoader } from "./YouTube";

export const renderLeftNav = (onClick, disabled) => {
  return <GalleryNavArrow className="nav-arrow left" onClick={onClick} />;
};

export const renderRightNav = (onClick, disabled) => {
  return <GalleryNavArrow className="nav-arrow right" onClick={onClick} />;
};

/**
 * Go from gallery to the Schedule A tour.
 */
const goToVirtualTour = () => {
  const state = store.getState();
  const datePickerModule = getModuleByType(state, ModuleTypes.datePicker);

  if (datePickerModule) {
    dispatch(goToModule(datePickerModule.id));
  }
};

/**
 * Render gallery item according to Content Types.
 */
export const renderGalleryItem = (item) => {
  if (item.contentType === GalleryItemType.YOUTUBE) {
    return (
      <div className="iframe-container">
        <YouTubeIframeLoader videoID={item.original} />
      </div>
    );
  }

  if (item.contentType === GalleryItemType.IFRAME) {
    return <div className="iframe-container" dangerouslySetInnerHTML={{ __html: item.original }} />;
  }

  if (item.contentType === "goToTour") {
    return (
      <GalleryBlurredItem>
        <img className="image-gallery-image" src={item.original} alt="" />
        <Overlay>
          <span>Interested In Touring This Community?</span>
          <TourButton onClick={goToVirtualTour}>Schedule A Tour</TourButton>
        </Overlay>
      </GalleryBlurredItem>
    );
  }

  return (
    <div>
      <img className="image-gallery-image" src={item.original} alt="" />
    </div>
  );
};

/**
 * Render thumbnail according to Gallery Item Type.
 */
export const renderGalleryThumbnail = (item) => {
  if (!item.thumbnail || item.contentType === GalleryItemType.IFRAME) {
    return (
      <div
        className="image-gallery-thumbnail-inner "
        style={{
          background: "#eaeff7",
          borderRadius: "7px",
          padding: "13px 2px",
          cursor: "pointer",
        }}
      >
        <VideosIcon />
      </div>
    );
  }
  return (
    <div
      className="image-gallery-thumbnail-inner"
      style={{ background: `url(${item.thumbnail}) center center / cover no-repeat`, minHeight: 55, borderRadius: 7 }}
    />
  );
};

/**
 * Blurred Image for gallery.
 */
const GalleryBlurredItem = styled.div`
  position: relative;
  text-align: center;

  .image-gallery-image {
    -webkit-filter: blur(10px);
    filter: blur(10px);
  }
`;

/**
 * Block for title text on a blurred image.
 */
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  font-size: 24px;
  line-height: 24px;
  color: white;
  white-space: normal;

  span {
    padding-bottom: 10px;
  }
`;

/**
 * Button for redirecting to "Schedule A Tour".
 */
const TourButton = styled.div`
  position: relative;
  display: block;
  padding: 10px 20px;
  background-color: ${(props) => props.theme.brandColor || "#2F80ED"};
  font-size: 17px;
  text-align: center;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease-out;

  &:hover {
    box-shadow: 0 2px 9px rgba(217, 217, 217, 0.5);
  }
`;
